import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import client from "../../lib/api";
import AdminLayout from "./AdminLayout";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Label } from "../../components/ui/label";

export default function Settings() {
  const [s, setS] = useState({});
  useEffect(() => { client.get("/admin/settings/site").then(({ data }) => setS(data || {})).catch(() => {}); }, []);
  const save = async () => {
    try { await client.put("/admin/settings/site", s); toast.success("Settings updated."); }
    catch { toast.error("Could not save."); }
  };
  return (
    <AdminLayout title="Website Settings">
      <div className="max-w-2xl space-y-5 rounded-md border border-gold/20 bg-white p-7">
        <div><Label>Website Title</Label><Input className="mt-1.5" value={s.websiteTitle || ""} onChange={(e) => setS({ ...s, websiteTitle: e.target.value })} data-testid="settings-title" /></div>
        <div><Label>Meta Description</Label><Textarea className="mt-1.5" rows={3} value={s.metaDescription || ""} onChange={(e) => setS({ ...s, metaDescription: e.target.value })} data-testid="settings-meta" /></div>
        <div><Label>Trust Email</Label><Input className="mt-1.5" value={s.trustEmail || ""} onChange={(e) => setS({ ...s, trustEmail: e.target.value })} data-testid="settings-email" /></div>
        <button onClick={save} data-testid="settings-save" className="bg-maroon px-6 py-3 text-xs uppercase tracking-wide text-ivory hover:bg-maroon-dark">Save Settings</button>
      </div>

      <div className="mt-6 max-w-2xl rounded-md border border-gold/20 bg-ivory p-7">
        <h3 className="flex items-center gap-2 font-medium text-maroon"><Lock size={16} /> Future Modules (currently disabled)</h3>
        <p className="mt-2 text-sm text-ink-muted">These modules are architected and will be activated in a future phase. They are intentionally disabled at launch.</p>
        <ul className="mt-4 grid gap-2 text-sm text-ink-muted sm:grid-cols-2">
          {["Online Donations", "Payment Gateway", "Donation Receipts", "Donation Reports", "Donor Management", "Mobile OTP Verification", "Volunteer Management", "Old Age Home Management"].map((m) => (
            <li key={m} className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-gold" /> {m} <span className="text-xs text-gold-dark">— Disabled</span></li>
          ))}
        </ul>
      </div>
    </AdminLayout>
  );
}
